// 量表预览
import request from '@/utils/request'
// 获取量表详情
export function getGaugeDetail(params) {
  return request({
    url: '/gauge/gauge',
    method: 'get',
    params
  });
}